/* 📦 LIBS */
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

/* 🧩 COMPONENTS */
import { EquipamentLine } from "../index.js"

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store/index.js";
import { ChangeEquipamentDataList } from "../../../../Redux/Actions/mapActions.js";

/* 📁 ASSETS*/
import { Fixado } from "../../../../Assets/icons";
import { ControlIcon, DashIcon } from "../../../../Assets/icons/MenuIcons/index.js";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, UnpinButton, UnpinImage, ButtonIcon, AccessButton, ButtonsContainer } from "./styles"

const EquipamentCard = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    let dados = props.dados
    let status = props.status

    const handleUnpinCard = ()=>{
        let list = JSON.parse(JSON.stringify(store.getState().mapReducer.EquipamentDataList));
        list = list.filter(equipament => equipament.id !== props.id[0]);
        store.dispatch(ChangeEquipamentDataList(list));
    }

    return(
        <Container>
            <UnpinButton id="close-card" onClick={() => handleUnpinCard()}>
                <UnpinImage src={Fixado} id={`${props.id[1]}`}/>
            </UnpinButton>
            <TitleContainer $background={status === 4 ? '#E1800E' : status === 3 ? '#6600CC' : status === 2 ? 
                '#FF3939': status === 1 ? '#EABC1A' : status === 0 ? '#33CC99' : '#F6F6F6'}>
                <Title $background={status === 4 ? '#E1800E' : status === 3 ? '#6600CC' : status === 2 ? 
                '#FF3939': status === 1 ? '#EABC1A' : status === 0 ? '#33CC99' : '#F6F6F6'}>{props.equipamento}</Title>
            </TitleContainer>
            {dados.map((dado, index)=>(
                <EquipamentLine key={index} dado={dado}/>
            ))}
            <ButtonsContainer>
                <AccessButton onClick={()=> navigate(`/dashboard/${props.id[0]}`)}>
                    <ButtonIcon src={DashIcon} fill={'#006560'}></ButtonIcon>
                    {t("buttons.dashboard")}
                </AccessButton>
                { props.type === '1f4d0674-1e7a-48c5-925f-87e2d99bcda5' && 
                    <AccessButton onClick={()=> navigate(`/controle/${props.id[0]}`)}>
                        <ButtonIcon src={ControlIcon} fill={'#006560'}></ButtonIcon>
                        {t("buttons.control")}
                    </AccessButton>}
            </ButtonsContainer>
        </Container>
    )
}

export default EquipamentCard;